import { SizeGuide } from '../../../ui/customer-support/components/size-guide';

const SizeGuideTastic = ({}) => {
  return <SizeGuide />;
};

export default SizeGuideTastic;
